// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__KY5e9","spin":"styles_spin__9HK4M"};